module.exports = __webpack_public_path__ + "img/symbol_2.066d585b.png";